import type { NewsCategoriesByType } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategoriesByType";
import { NewsCategory } from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsCategory";
import NewsSignalSubType from "app/pages/sales-intelligence/sub-modules/signals/models/news/NewsSignalSubType";

export const NEWS_CATEGORIES_BY_TYPE: NewsCategoriesByType = {
    [NewsSignalSubType.Leadership]: [
        NewsCategory.Hires,
        NewsCategory.Promotes,
        NewsCategory.Leaves,
        NewsCategory.Retires,
    ],
    [NewsSignalSubType.Growth]: [
        NewsCategory.OpensNewLocation,
        NewsCategory.ExpandsOfficesIn,
        NewsCategory.ExpandsOfficesTo,
        NewsCategory.ExpandsFacilities,
        NewsCategory.SignsNewClient,
        NewsCategory.IncreasesHeadcountBy,
        NewsCategory.AttendsEvent,
    ],
    [NewsSignalSubType.Strategy]: [
        NewsCategory.Acquires,
        NewsCategory.MergesWith,
        NewsCategory.Launches,
        NewsCategory.IntegratesWith,
        NewsCategory.IsDeveloping,
        NewsCategory.PartnersWith,
        NewsCategory.EndsPartnershipWith,
        NewsCategory.SellsAssetsTo,
        NewsCategory.IdentifiedAsCompetitorOf,
        NewsCategory.SpinsOffCompany,
        NewsCategory.SpinsOffDivision,
    ],
    [NewsSignalSubType.Investment]: [
        NewsCategory.ReceivesFinancing,
        NewsCategory.InvestsInto,
        NewsCategory.InvestsIntoAssets,
        NewsCategory.GoesPublic,
        NewsCategory.HasEarnings,
        NewsCategory.HasRevenue,
        NewsCategory.HasValuation,
    ],
    [NewsSignalSubType.CompanyChallenges]: [
        NewsCategory.ClosesOffices,
        NewsCategory.DecreasesHeadcountBy,
        NewsCategory.FilesSuitAgainst,
        NewsCategory.HasIssuesWith,
        NewsCategory.DeclaresBankruptcy,
        NewsCategory.LosesClient,
    ],
    [NewsSignalSubType.Recognition]: [NewsCategory.ReceivesAward, NewsCategory.RecognizedAs],
};
